var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { createCallback, createInputEvent, aliasProps } from '../../createHostComponent';
import alias from './props/alias';
var Textarea = /** @class */ (function (_super) {
    __extends(Textarea, _super);
    function Textarea(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: '',
            // 阿里
            controlled: false,
        };
        _this.handleInput = function (e) {
            var controlled = _this.state.controlled;
            if (!controlled) {
                _this.setState({ value: e.target.value });
            }
            if (typeof _this.props.onInput === 'function') {
                return _this.props.onInput(e);
            }
            // 微信
            // 注意，微信要对 input 受控，必须要在 onInput 方法返回值
            return controlled ? _this.props.value : e.target.value;
        };
        var controlled = props.value !== undefined;
        var value = controlled ? props.value : props.defaultValue;
        _this.state = {
            value: value,
            controlled: controlled,
        };
        return _this;
    }
    Textarea.prototype.componentDidUpdate = function () {
        if (this.props.value !== undefined && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value });
        }
    };
    Textarea.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var inputProps = __assign(__assign({}, this.props), { onInput: createCallback(this.handleInput, createInputEvent) });
        if (inputProps.onConfirm) {
            inputProps.onConfirm = createCallback(this.props.onConfirm, createInputEvent);
        }
        if (inputProps.onFocus) {
            inputProps.onFocus = createCallback(this.props.onFocus, createInputEvent);
        }
        if (inputProps.onBlur) {
            inputProps.onBlur = createCallback(this.props.onBlur, createInputEvent);
        }
        if (process.env.REMAX_PLATFORM === 'toutiao') {
            inputProps.maxLength = (_a = inputProps.maxLength) !== null && _a !== void 0 ? _a : 140;
        }
        if (process.env.REMAX_PLATFORM === 'wechat') {
            inputProps.maxLength = (_b = inputProps.maxLength) !== null && _b !== void 0 ? _b : 140;
            inputProps.disabled = (_c = inputProps.disabled) !== null && _c !== void 0 ? _c : false;
            inputProps.focus = (_d = inputProps.focus) !== null && _d !== void 0 ? _d : false;
            inputProps.autoHeight = (_e = inputProps.autoHeight) !== null && _e !== void 0 ? _e : false;
        }
        var nextProps = aliasProps(__assign(__assign({}, inputProps), this.state), alias);
        return React.createElement('textarea', nextProps);
    };
    Textarea.defaultProps = {
        'toutiao-selection-end': 999,
        'toutiao-selection-start': 999,
        'wechat-selection-end': -1,
        'wechat-selection-start': -1,
        'wechat-fixed': false,
        'wechat-placeholder-class': 'textarea-placeholder',
        'wechat-cursor-spacing': 0,
        'wechat-cursor': -1,
        'wechat-show-confirm-bar': true,
        'wechat-adjust-position': true,
        'wechat-hold-keyboard': false,
        'wechat-disable-default-padding': false,
    };
    return Textarea;
}(React.Component));
export default Textarea;
